import { render, staticRenderFns } from "./EditOrderDetails.vue?vue&type=template&id=d1eb71c0&scoped=true"
import script from "./EditOrderDetails.vue?vue&type=script&lang=js"
export * from "./EditOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./EditOrderDetails.vue?vue&type=style&index=0&id=d1eb71c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1eb71c0",
  null
  
)

export default component.exports